import { createEndpoint } from '@/shared/models/api';
import { UserInformation } from '@/app/api/morgan-thermal/user';

export const getCurrentUser = createEndpoint<UserInformation>(({fetch}) => () => fetch('/User/getCurrentUser'));